"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_common_1 = require("@agilepoint/utils-common");
function groupBy(array, keySelector, valueSelector) {
    return array.reduce((prev, curr) => {
        const groupKey = keySelector(curr);
        const groupValue = valueSelector(curr);
        const groupItems = prev.get(groupKey) || new Set();
        groupItems.add(groupValue);
        prev.set(groupKey, groupItems);
        return prev;
    }, new Map());
}
exports.groupBy = groupBy;
function compareValues(left, right) {
    if (left === right) {
        return 0;
    }
    if (utils_common_1.isString(left) && utils_common_1.isString(right)) {
        return left.localeCompare(right, 'en', { sensitivity: 'base' }) > 0 ? 1 : -1;
    }
    return left > right ? 1 : -1;
}
function sortBy(array, keySelector, isSortedDescending = false) {
    return array.slice().sort((a, b) => {
        const left = keySelector(a);
        const right = keySelector(b);
        const result = compareValues(left, right);
        return isSortedDescending ? (result * -1) : result;
    });
}
exports.sortBy = sortBy;
function eachSeries(array, iterator) {
    let index = 0;
    const next = async () => {
        if (index >= array.length) {
            return;
        }
        const currentIndex = index++;
        const item = array[currentIndex];
        return iterator(item, currentIndex, array).then(next);
    };
    return next();
}
exports.eachSeries = eachSeries;
function mapSeries(array, iterator) {
    return new Promise((resolve, reject) => {
        const items = new Array();
        eachSeries(array, async (_item, _index, _array) => iterator(_item, _index, _array).then(res => { items.push(res); }))
            .then(() => resolve(items))
            .catch(reject);
    });
}
exports.mapSeries = mapSeries;
function reduceSeries(array, iterator, initialValue) {
    return new Promise((resolve, reject) => {
        let result = initialValue;
        eachSeries(array, async (currentItem) => iterator(result, currentItem).then(res => { result = res; }))
            .then(() => resolve(result))
            .catch(reject);
    });
}
exports.reduceSeries = reduceSeries;
function reduce(array, reducerPropSelector) {
    return array.reduce((prev, curr) => {
        prev[reducerPropSelector(curr)] = curr;
        return prev;
    }, {});
}
exports.reduce = reduce;
function defaultUniquePropsSelector(item) {
    return item;
}
function unique(array, propSelector = defaultUniquePropsSelector) {
    let uniqueValue;
    return array.filter((item, index) => {
        uniqueValue = propSelector(item);
        return array.findIndex((i => propSelector(i) === uniqueValue)) === index;
    });
}
exports.unique = unique;
function sortMapByKey(map, isSortedDescending = false) {
    const mapArray = Array.from(map);
    return new Map(sortBy(mapArray, (item) => item[0], isSortedDescending));
}
exports.sortMapByKey = sortMapByKey;
function sortItems(items, sortConfig = { sortByKey: '', isSortedDescending: false }) {
    return sortConfig.sortByKey ? sortBy(items, (i) => i[sortConfig.sortByKey], sortConfig.isSortedDescending) : items;
}
exports.sortItems = sortItems;
function ensureArray(item) {
    return (item !== undefined ? (utils_common_1.isArray(item) ? item : [item]) : []);
}
exports.ensureArray = ensureArray;
//# sourceMappingURL=array.js.map